import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'root/lib/apiClient';
import { Sentry } from 'root/utils/raven';

const initialState = {
  content: {},
  isLoading: false,
  error: null
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    getHomeStart(state) {
      state.isLoading = true;
    },
    getHomeSuccess(state, { payload }) {
      state.content = payload;
      state.isLoading = false;
      state.error = null;
    },
    getHomeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getHomeStart,
  getHomeSuccess,
  getHomeFailure,
} = homeSlice.actions;

export default homeSlice.reducer;

export const fetchHome = () => async (dispatch, getState) => {
  const { home } = getState();
  if (home.content?.length) {
    dispatch(getHomeSuccess(home.content));
  } else {
    try {
      dispatch(getHomeStart());
      const data = await apiClient({ method: 'GET', url: '/wp-json/mc/v2/home' });
      dispatch(getHomeSuccess(data));
    } catch (e) {
      dispatch(getHomeFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};
